/* eslint-disable react/prop-types */
import React from 'react';

import styled from 'styled-components';

import { device } from 'helpers/screenSizes';
import { Conversion } from 'styles/assets/icons';

const CurrencyConversionWrapper = styled.div`
  font-size: 14px;
  font-family: var(--fontRegular);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;

  @media ${device.down.lg} {
    font-size: 12.1px;
  }

  .text {
    padding-top: 5px;
  }

  .icon-span {
    padding: 0px 8px 0px 0px !important;
  }

  .span-convert {
    font-family: var(--fontRegular);
    margin-left: 10px;
  }
`;

export const CurrencyConversionOption = ({ openCurrencyConverterPopup }) => (
  <CurrencyConversionWrapper>
    <div
      data-testid="open-currency-converter-popup"
      aria-hidden="true"
      onClick={openCurrencyConverterPopup}
    >
      <Conversion />
      <span className="span-convert">Convert</span>
    </div>
  </CurrencyConversionWrapper>
);
